import React from 'react';

const MeasurementTitle = ({ title }) => <h3 className={'measurement-title'}>{title}</h3>;

export default MeasurementTitle;
